<template>
    <div class="interfaceAuthor-slider">
        <div class="tree-con">
            <el-tree
                :data="treeData"
                :props="defaultProps"
                :highlight-current="true"
                :expand-on-click-node="false"
                node-key="id"
                :default-expanded-keys="defaultKey"
                :current-node-key="currentNodeKey"
                class="businessGroupWh-slider-tree"
                ref="tree"
            >
                <span class="slot-t-node" slot-scope="{ node, data }">
                    <div class="parent-node" v-if="data.directory_type===0">
                        <i v-if="node.expanded" class="iconfont iconshouqi" @click.stop="expandtree(node)"></i>
                        <i v-if="!node.expanded" class="iconfont iconzhankai" @click.stop="expandtree(node)"></i>
                        <span v-if="node.expanded" class="iconfont iconwenjianjia-zhankai" @click.stop="expandtree(node)"></span>
                        <span v-if="!node.expanded" class="iconfont iconwenjianjia-shouqi" @click.stop="expandtree(node)"></span>
                        <span>{{ data.name }}</span>
                    </div>
                    <div class="leaf-node" v-else @click="loadTable(data.id)">
                        <span class="iconfont iconlingxing"></span>
                        <span>{{ data.name }}</span>
                    </div>
                </span>
            </el-tree>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            treeData: [],
            defaultProps: {
                children: 'children',
                label: 'name',
            },
            defaultKey: [], // 默认展开节点id集合
            currentNodeKey: '', // 当前节点key
            menuVisible: false,
            currentNode: {}, // 当前节点数据
        };
    },
    watch: {},
    computed: {},
    methods: {
        // 展开节点
        expandtree(node) {
            node.expanded = !node.expanded;
            if (node.expanded) {
                this.defaultKey = [];
                this.defaultKey.push(node.data.id);
            } else {
                this.defaultKey = [];
            }
        },

        // 拉取业务分组树
        getTree() {
            this.$axios
                .get('/interfaceApi/datacenter/interface/info/gettree')
                .then(res => {
                    this.treeData = res;
                    const obj = this.getFirstLeafNode(res);
                    this.$emit('load-data', obj.id);
                    this.defaultKey = [];
                    this.defaultKey.push(obj.id);
                    this.currentNodeKey = obj.id;
                    this.$nextTick(() => {
                        this.$refs.tree.setCurrentKey(obj.id);
                    });
                })
                .catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
        },
        // 递归查找第一个叶子节点
        getFirstLeafNode(data) {
            let obj = null;
            if (data && data.length > 0) {
                const item = data[0];
                if (item.children.length === 0) {
                    obj = item;
                } else {
                    obj = this.getFirstLeafNode(item.children);
                }
            }
            return obj;
        },
        // 新增完成更新树
        handleCallBack() {
            this.getTree();
        },
        // 加载表格
        loadTable(id) {
            this.currentNodeKey = id;
            this.$emit('load-data', id);
        },
    },
    created() {
        this.getTree();
    },
    mounted() {},
};
</script>
<style lang="stylus" scoped>
.interfaceAuthor-slider
    width 220px
    height 100%
    background #fff
    overflow hidden
    float left
    .new-module
        height 44px
        background #F8F8F8
        border-bottom 1px solid #D7D7D7
        line-height 44px
        color #333
        cursor pointer
        .iconxianshi_tianjia
            margin 0 9px 0 12px
        &:hover
            color #5588F1
    .tree-con
        height 100%
        overflow-y auto
        overflow-x auto
        .slot-t-node
            line-height 38px
            height 38px
            .parent-node
                .iconzhankai
                    color #5588F1
                .iconshouqi
                    color #F19F26
                .iconwenjianjia-shouqi
                    color #5588F1
                .iconwenjianjia-zhankai
                    color #F19F26
                .iconfont
                    margin-right 10px
            .leaf-node
                color #666666
                .iconlingxing
                    color #979EA7
                    margin 0 10px 0 0
                    font-size 14px
    .more-menu
        width 170px
        position absolute
        border 1px solid #d3d5d4
        box-shadow 0 0 5px #d3d5d4
        border-bottom none
        z-index 1000
        .iconfont
            margin-right 10px
        .menu-name
            background #f8f8f8
        .el-menu
            border-right none
            .el-menu-item
                border-bottom 1px solid #f0f0f0
                height 38px
                line-height 38px
                &:focus
                    background-color #1577d2
                    color #fff
        .header
            background #5588F1
            color #fff
            text-align center
            font-size 16px
            line-height 32px!important
</style>
<style>
.interfaceAuthor-slider .el-icon-caret-right:before{
    display: none!important;
}
.interfaceAuthor-slider .el-tree-node__content{
    height: 36px;
}
.interfaceAuthor-slider .tree-con .is-current>.el-tree-node__content .slot-t-node .leaf-node{
    color: #FE7903;
}
.interfaceAuthor-slider .tree-con .is-current>.el-tree-node__content .slot-t-node .leaf-node .iconlingxing{
    color: #FE7903;
}
.interfaceAuthor-slider .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
    background-color:#E2EAF0;
}
</style>